module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="apexchat_question_type_multiple_choice_radio"\r\n    id="apexchat_question_type_multiple_choice_radio_parent_option_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'">\r\n    <input type="radio" name="apexchat_question_type_radio_group_' +
((__t = (messageId)) == null ? '' : __t) +
'"\r\n        id="apexchat_scripts_radio_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" value="' +
((__t = (name )) == null ? '' : __t) +
'" />\r\n    <label class="apexchat_question_type_multiple_choice_radio_label livechat_btn livechat_btn_hollow"\r\n        for="apexchat_scripts_radio_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'">\r\n        <span><!-- This span is needed to create the "checkbox" element --></span>\r\n        <div class="apexchat_text livechat_btn_item livechat_btn_inner apexchat_question_type_multiple_choice_radio_label_align apexchat_element_on_focus apexchat_qt_button_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'"\r\n            tabindex="0" id="apexchat_question_type_multiple_choice_radio_option_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'"\r\n            style="' +
((__t = (styles )) == null ? '' : __t) +
' ">\r\n            ' +
((__t = (name )) == null ? '' : __t) +
'\r\n        </div>\r\n    </label>\r\n</div>';

}
return __p
}